var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAreaMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15274_239126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1854 17.4374C20.6761 18.0708 21.5806 18.9028 21.5806 19.8139C21.5806 21.7981 17.2912 23.4067 11.9998 23.4067C6.70843 23.4067 2.41895 21.7981 2.41895 19.8139C2.41895 18.9028 3.32346 18.0708 4.81415 17.4374",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9878 8.37014C17.9878 12.074 11.9997 18.6163 11.9997 18.6163C11.9997 18.6163 6.01172 12.074 6.01172 8.37014C6.01172 4.6662 8.69265 1.84985 11.9997 1.84985C15.3068 1.84985 17.9878 4.6662 17.9878 8.37014Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 9.03548C12.6618 9.03548 13.1979 8.4993 13.1979 7.83788C13.1979 7.17646 12.6618 6.64027 12.0003 6.64027C11.3389 6.64027 10.8027 7.17646 10.8027 7.83788C10.8027 8.4993 11.3389 9.03548 12.0003 9.03548Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15274_239126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.628296)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaMap);
export default __webpack_public_path__ + "static/media/area-map.dec25db5e2fef03027c71f8dfa924f5a.svg";
export { ForwardRef as ReactComponent };